import { Formik } from 'formik';
import { object, date } from 'yup';
import React, { useMemo, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { trigger } from 'swr';

import { patchMemoir, postPrivateEventDetails } from '../api';
import { prepareAttrs } from '../../utils/api';
import { useEntity, useEntityActionCreators } from '../../entities/hooks';
import { useHistory, useJsDate, useMatch } from '../../app/hooks';
import FullPageForm from '../../app/full-page-form';
import NewCollectionDate from '../../collections/new/date';
import { requestEntities } from '../../entities/actions';
import { postMilestone } from '../milestones/api';
import { useLocation } from 'react-router-dom';
import { checkIfPublicRoute } from 'app/form/helper';

const MemoirDate = () => {
  const { push } = useHistory();
  const { params } = useMatch();
  const { entity } = useEntity(params);
  const { receive } = useEntityActionCreators();
  const initialDate = entity['date-of-birth'];
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const isPublicRoute = checkIfPublicRoute(pathname);

  useEffect(() => {
    return () => trigger('/v3/my/chronicle_collection');
  }, []);

  const initialValues = {
    'date-of-birth': initialDate || null,
  };
  const validationSchema = object().shape({
    'date-of-birth': date(),
  });
  const isInitialValid = validationSchema.isValidSync(initialValues);

  const label = useMemo(
    () =>
      entity['subject-relation'] === 'me'
        ? 'When were you born?'
        : `When was ${entity['first-name']} born?`,
    [entity]
  );
  const backPath = useMemo(
    () => (entity['subject-relation'] === 'me' ? 'memoir-name' : 'subject-name'),
    [entity]
  );
  return (
    <FullPageForm
      onBackClick={() => push(`/memoirs/new/${entity.id}/${backPath}`)}
      title="Create a Memoir"
    >
      <Formik
        {...{ initialValues, validationSchema, isInitialValid }}
        enableReinitialize
        onSubmit={async values => {
          const body = prepareAttrs({
            ...values,
            'lock-version': entity['lock-version'],
          });

          // PATCH child journal
          const cjRes = await patchMemoir({ id: entity.id, ...body });
          const [id] = cjRes.data.result.memoirs;
          receive({ payload: cjRes });
          if (!(entity['milestone-shares'] || []).length) {
            dispatch(
              requestEntities(
                postMilestone({
                  memoirId: entity.id,
                  attributes: {
                    'start-date': values['date-of-birth'],
                    name: `${entity['subject-name']} was born`,
                    'milestone-kind': 'birth',
                  },
                })
              )
            );
          }
          push(`/memoirs/${isPublicRoute ? 'get-started' : 'new'}/${id}/is-with-us`);
          if (isPublicRoute) {
            postPrivateEventDetails('memoir_when_was_subject_born_clicked_next', {
              'subject-type': 'Memoir',
              'subject-id': id,
            });
          }
        }}
        render={formikProps => (
          <NewCollectionDate
            label={label}
            skipPath={`/memoirs/${isPublicRoute ? 'get-started' : 'new'}/${entity.id}/is-with-us`}
            isPublicRoute={isPublicRoute}
            {...formikProps}
          />
        )}
      />
    </FullPageForm>
  );
};

export default MemoirDate;
